// API client functions for node policy endpoints.
// Covers approval policy configuration on category tree nodes.

import type { ApiClient } from '@/lib/api/client'

// --- Types ---

export type NodeType = 'control_category' | 'action_category'
export type PolicyType = 'independent_assessment' | 'closure_approval'

export interface PolicyConfig {
  role_id: string
}

export interface NodePolicyItem {
  node_id: string
  policy_type: PolicyType
  enabled: boolean
  config?: PolicyConfig
  role_name?: string
}

export interface NodePolicyListResponse {
  policies: NodePolicyItem[]
}

export interface EffectivePolicy {
  policy_type: PolicyType
  enabled: boolean
  config?: PolicyConfig
  role_name?: string
  is_inherited: boolean
  inherited_from_node_id?: string
  inherited_from_node_name?: string
}

export interface SetPolicyRequest {
  role_id: string
}

// --- API factory ---

export function nodePoliciesApi(api: ApiClient) {
  return {
    list: (nodeType: NodeType): Promise<NodePolicyListResponse> =>
      api.get(`/node-policies/${nodeType}`),

    getEffective: (nodeType: NodeType, nodeId: string): Promise<EffectivePolicy> =>
      api.get(`/node-policies/${nodeType}/${nodeId}`),

    set: (nodeType: NodeType, nodeId: string, data: SetPolicyRequest): Promise<NodePolicyItem> =>
      api.put(`/node-policies/${nodeType}/${nodeId}`, data),

    remove: (nodeType: NodeType, nodeId: string): Promise<void> =>
      api.del(`/node-policies/${nodeType}/${nodeId}`),
  }
}
